/* eslint-disable max-len */
import { ICONS_ID } from '@bitComponents/unifiedIcons/SvgIconLoader';
import { CQ_ACTION_CODES, CQ_POTS } from '../../../catalogConstants';
import { STRING_KEYS } from '../../common';
import { USER_TYPE } from '../../../bitConstants/constants';

export const localizedStrings = {
  common: {
    everyMainSelection: {
      [STRING_KEYS.stepTitles.selectParentProduct]: 'Elige el producto en el que quieres contratar Movistar Plus+.',
      [STRING_KEYS.se.risk.subject]: 'TELCOBI MOVISTAR PLUS Riesgo Error 800',
      [STRING_KEYS.se.order.subject]: 'TELCOBI MOVISTAR PLUS Error TELCO',
      [STRING_KEYS.summary.title]: 'Quiero contratar Movistar Plus+',
      [STRING_KEYS.summary.staticDirectDebit]: 'El pago de este servicio se realizará en tu factura Movistar.',
      [STRING_KEYS.summary.cart.recurringChargesFinalPriceTextBelow[CQ_POTS.PAYMENT_POT.DIRECT_DEBIT_ID]]: '',
      [STRING_KEYS.confirmation.subtitle]: 'Recuerda que recibirás un correo desde el que tendrás que crear tu cuenta de Movistar Plus+.',
      [STRING_KEYS.confirmation.subtitle2]: 'En caso de no recibir el correo, también podrás crear la cuenta desde tu área privada.',
      [STRING_KEYS.genesys.campaign]: 'ret-genesys-ott',
      [STRING_KEYS.payment.step.insertDirectDebit]: 'Necesaria por si se generan cargos adicionales por compra o alquiler de contenidos.',
      [STRING_KEYS.payment.step.chooseDirectDebit]: 'Necesaria por si se generan cargos adicionales por compra o alquiler de contenidos.',
      [STRING_KEYS.payment.step.icon]: ICONS_ID.Informacion,
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.TELCO}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.OPEN}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
};
